<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="650px">
                <v-card>
                    <v-card-title class="justify-center">
                        <span> Create Custom Document </span>
                        <v-btn icon absolute top right color="red" @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn> <!-- closeDialog -->
                    </v-card-title>
                    
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="submitForm" 
                        ><!-- submitForm -->
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                            v-model="academic_session"
                                            :items="currentInstitution.academic_sessions"
                                            small-chips
                                            outlined
                                            color="primary"
                                            label="Filter by Academic Year"
                                            hide-details
                                            dense
                                            background-color="transparent"
                                            item-value="id"
                                            item-text="title"
                                            class="mb-4 rounded-input"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12">
                                        <v-autocomplete
                                            :search-input.sync="search"
                                            :items="allStudents"
                                            v-model="selectedStudent"
                                            color="primary"
                                            label="Select Student"
                                            hide-details
                                            clearable
                                            dense
                                            :rules="[ rules.required ]"
                                            placeholder="Start typing to search..."
                                            background-color="transparent"
                                            item-value="id"
                                            item-text="full_name"
                                            class="mb-5 mt-2 rounded-input"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="12" sm="12" v-for="(key, property, index) in context" :key="index">
                                        <v-text-field
                                            :rules="[rules.required]"
                                            :label="property.replaceAll('_',' ') + `*`"
                                            :id="property"
                                            :placeholder="key"
                                            v-model="formData[property]"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="2" sm="2"></v-col>
                                    <v-col cols="12" md="8" sm="8">
                                        <v-btn
                                            block
                                            color="indigo"
                                            class="white--text"
                                            @click="saveDocumentInstance()"
                                            :disabled="!submitForm"
                                        > Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>

                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
    </div>
</template>


<script>
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import Helper from "@utils/misc";

export default {
    name: "DocumentInstanceDialog",
    props: {
        selectedDocumentType: {
            type: Number,
            default(){
                return null;
            },
        },
        dialog: {
            type: Boolean,
            default() {
                return false;
            },
        },
        formFields:{
            type: Array,
            default(){
                return [];
            }
        },
        is_editing:{
            type: Boolean,
            default(){
                return false;
            }
        },
        selectedDocumentInstance:{
            type: Object,
            default(){
                return null;
            }
        }
    },

    computed: {
        ...mapGetters([
            "currentUser",
            "accessToken",
            "isLoading",
            "currentInstitution",
        ]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },

    data(){
        return {
            search: null,
            allStudents: [],
            selectedStudent: null,
            submitForm: false,
            context: null,
            allDocumentTypes: null,
            rules: {
                required: (value) => !!value || "Required"
            },
            formData:{},
            snackbar: {
                visible: false,
                text: "",
            },
            academic_session: null,
            
        }
    },

    methods:{
        ...mapActions(["setLoading"]),

        async getFormFields(){
            var url = endpoints.documentTypes;
            var response = await api.call(this.essentials, url);
            if(response){
                this.allDocumentTypes = response;
            }
        },

        closeDialog(){
            this.$emit("closeDialog");
            /*var self = this;
            setTimeout(()=>{
                self.context = null;
                self.allDocumentTypes = null
            }, 400); */
            this.dialog = false;
            this.formData = {};
        },

        async saveDocumentInstance(){
            var body = {
                institution: this.currentInstitution.id,
                template_document_type: this.selectedDocumentType,
                data: JSON.stringify(this.formData),
                student: this.selectedStudent,
            }
            var url = "";
            if(this.is_editing)
                url = endpoints.documentInstances + this.selectedDocumentInstance.id + "/update/";
            else
                url = endpoints.documentInstances;
    
            var response = await api.call(this.essentials, url, api.Methods.POST, body);
            if(response){
                this.dialog = false;
            }else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        // get all students from the server
        async getAllStudents(searchQuery) {
            var response;
            
            // if search query exists, add to the url as a GET param w/o disturbing other params
            if (searchQuery) {
                var url = endpoints.getAllStudents;
                url = Helper.addUrlParams(url, 'query=' + searchQuery);
            }

            if (this.academic_session) {
                url = Helper.addUrlParams(url, "session=" + this.academic_session);
            }

            response = await api.call(this.essentials,url);

            if (response) {
                this.allStudents = response.results;
            }

            
        },

        // handles api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },
    },

    created(){
        this.getFormFields();
        this.academic_session = this.currentInstitution.academic_sessions.find(s => s.active).id;
    },

    updated(){
        this.getFormFields();
    },
    watch:{
        dialog:{
            async handler(){
                if(!this.dialog) this.closeDialog();
            }        
        },

        selectedDocumentType: function(newVal) {
            const documentType = this.allDocumentTypes.filter(function(el){
               return  el.id == newVal
            })
            if(documentType){
                try{
                    this.context = JSON.parse(documentType[0].sample_context);
                    this.context = Object.fromEntries(Object.entries(this.context).filter(([key]) => this.context[key][0] != "=" ))
                    for (const [key, value] of Object.entries(this.context)) {
                        if(value[0] == "#")
                            this.formData[key] = value.slice(1)
                    }
                }catch(err) {
                    this.snackbar.text = "Problem fetching data for this document type, contact support" + err
                    this.snackbar.visible = true
                }
            }else{
                this.snackbar.text = "Document type not found, contact support"
                this.snackbar.visible = true
            }

        },
        search: {
            async handler(value) {
                if(!value || value.trim().length===0) {
                    this.allStudents = [];
                    return;
                }
                // this.options.page = 1;
                var searched = this.search;
                var self = this;
                setTimeout(function () {
                if (searched == self.search) {
                    self.getAllStudents(value);
                }
                }, 500);
            },
        },
        
        is_editing: function(newVal){
            if(newVal)
                this.formData = JSON.parse(this.selectedDocumentInstance.data);
                this.selectedStudent = this.selectedDocumentInstance.student.id
                this.allStudents = [this.selectedDocumentInstance.student]
        },
    }

}
</script>